export default __webpack_public_path__ + "alberta-upload.fb1c862ed493a31496b8.svg";